import Button from "Components/Elements/Button";
import Config from "Configs";
import React from "react";
import Wallet, { IWallet } from "Stores/Wallet";

type IProps = {
	onClick?: () => void;
	disabled?: boolean;
	isButtonLoading: boolean;
};
type IState = {
	userAddress: string | null;
};

export default class MintConnectWallet extends React.Component<IProps, IState> {
	private removeOnChange = () => {};

	constructor(props: IProps) {
		super(props);
		this.state = {
			userAddress: Wallet.getInstance().walletData?.userAddress ?? null,
		};
	}

	public render(): JSX.Element {
		const isConnected = !!this.state.userAddress;
		const contract = Config.getInstance().get().contracts.nftCollection.address;

		if (this.props.disabled || !contract) {
			return (
				<Button variant="primary" disabled={true}>
					MINT CLOSED
				</Button>
			);
		}
		if (this.props.isButtonLoading) {
			return (
				<Button variant="primary" onClick={this.props.onClick} disabled={this.props.disabled}>
					Loading
				</Button>
			);
		}
		return (
			<>
				{!isConnected && (
					<Button variant="primary" onClick={() => this.connect()}>
						CONNECT WALLET
					</Button>
				)}
				{isConnected && (
					<Button variant="primary" onClick={this.props.onClick} disabled={this.props.disabled}>
						MINT
					</Button>
				)}
			</>
		);
	}

	public componentDidMount() {
		this.removeOnChange = Wallet.getInstance().onChange((web3Event: IWallet | null) => this.onChange(web3Event));
	}

	public componentWillUnmount() {
		this.removeOnChange();
	}

	private async connect(): Promise<void> {
		Wallet.getInstance().connect();
	}

	private onChange(walletData: IWallet | null) {
		this.setState({
			userAddress: walletData?.userAddress ?? null,
		});
	}
}
